module.exports = __webpack_public_path__ + "img/APP界面slogan_画板 1 1@2x.ef88224f.png";